import { Injectable } from '@angular/core';
import { Auth, API } from 'aws-amplify';
import { Group } from '../models/group';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  apiName = 'AdminQueries';
  nextToken;

  constructor() { }

  updateGroups(user: string, groups: Group[], origGroups: Group[]) {

    if (origGroups.length === 0) {
      groups.forEach(n => {
        this.addGroup(user, n);
      });
    } else if (groups.length === 0) {
      origGroups.forEach(n => {
        this.removeGroup(user, n);
      });
    } else {
      groups.forEach(n => {
        const i = origGroups.findIndex(x => x.Name === n.Name);

        if (i === -1) {
          this.addGroup(user, n);
        }
      });

      origGroups.forEach(n => {
        const i = groups.findIndex(x => x.Name === n.Name);

        if (i === -1) {
          this.removeGroup(user, n);
        }
      });
    }

  }

  async addGroup(user: string, group: Group) {
    const path = '/addUserToGroup';
    const query = {
      body: {
        username: user,
        groupname: group.Name
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    };

    return API.post(this.apiName, path, query);
  }

  async removeGroup(user: string, group: Group) {
    const path = '/removeUserFromGroup';
    const query = {
      body: {
        username: user,
        groupname: group.Name
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    };

    return API.post(this.apiName, path, query);
  }

  async DisableUser(user: string) {
    const path = '/disableUser';
    const query = {
      body: {
        username: user
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    };

    return API.post(this.apiName, path, query);
  }

  async EnableUser(user: string) {
    const path = '/enableUser';
    const query = {
      body: {
        username: user
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    };

    return API.post(this.apiName, path, query);
  }

  async ListUsers() {
    const path = '/listUsers';
    const query = {
      queryStringParameters: {
        token: this.nextToken
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    };

    const { NextToken, ...rest } = await API.get(this.apiName, path, query);

    this.nextToken = NextToken;

    return rest;
  }

  async GetUserGroups(user: string) {
    const path = '/listGroupsForUser';
    const query = {
      queryStringParameters: {
        username: user
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    };

    return await API.get(this.apiName, path, query);
  }

  async GetGroups() {
    const path = '/listGroups';
    const query = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    };

    return await API.get(this.apiName, path, query);
  }
}
